var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Base',{attrs:{"detail":_vm.detail.customerInfo || {}}}),_c('Customer',{attrs:{"detail":_vm.detail.customerInfo || {}}}),_c('Stocking',{attrs:{"detail":_vm.detail}}),_c('Harvest',{attrs:{"detail":_vm.detail}}),_c('CustomerFeedback',{attrs:{"detail":_vm.detail.feedback || {},"detailUpload":_vm.detail}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }